// extracted by mini-css-extract-plugin
export default {"about":"band-details-view-styles__about","gigs":"band-details-view-styles__gigs"};